import { ReactPlugin } from '@microsoft/applicationinsights-react-js';
import { ApplicationInsights, DistributedTracingModes } from '@microsoft/applicationinsights-web';
import { appConfig } from './AppConfig';
import { isMsalHiddenIframe } from './Security/msalEnvironment';

const reactPlugin = new ReactPlugin();
const connectionString = appConfig.APP_INSIGHTS_CONNECTION_STRING;

const appInsights = new ApplicationInsights({
    config: {
        connectionString: connectionString,
        enableAutoRouteTracking: true,
        disablePageUnloadEvents: ['unload'],
        // nothing that happens in MSAL's hidden token-renewal iframe is worth reporting
        disableTelemetry: isMsalHiddenIframe(),
        // extensions: [reactPlugin],
        // distributedTracingMode: DistributedTracingModes.W3C,
        // enableCorsCorrelation: true,
    },
});

// expected MSAL states during silent token renewal or concurrent redirects, reported by MSAL as errors
const benignErrorMessages = [
    'ResizeObserver loop',
    'interaction_in_progress',
    'block_iframe_reload',
    'hash_empty_error',
    'redirect_in_iframe',
];

if (connectionString && connectionString.length) {
    appInsights.loadAppInsights();

    // benign browser/MSAL noise surfaced via window.onerror, not a real error: drop it before it's sent
    appInsights.addTelemetryInitializer((item) => {
        if (item.baseType !== 'ExceptionData') return true;
        const message = (item.baseData?.exceptions?.[0]?.message ?? item.baseData?.message ?? '') as string;
        if (benignErrorMessages.some((benign) => message.includes(benign))) return false;
        return true;
    });
}

export { appInsights, reactPlugin };
